import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}

#options{
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-top: 20px;
  justify-content: space-evenly;
}

#reports{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 5px;
}

#files{
  display: flex;
  flex-direction: column;
  gap: 5px;
}

label{
  display: flex;
  justify-content: center;
  align-items:center;
  margin:0;
  width:200px;
  height: 30px;
  cursor: pointer;
  color: white;
  font-size: ${props => props.theme.spacing.spacing_05};//16px;
  box-shadow: 1px 1px 5px #555;
  border-radius: 5px; 
  background-color: ${props => props.theme.colors.green};
}

.btn{
  display: flex;
  height: clamp(50px, 20vmin, 400px);
  width: clamp(50px, 20vmin, 400px);
  align-items: center;
  justify-content: center;
}

`